import React, { useContext } from "react";
import { theme } from "../theme";
import Current from "../components/Current";
import Criteria from "../components/Criteria";
import { General } from "../tools/styles";
import Generic from "../components/Generic";
import RenderIf from "../components/RenderIf"
import {WatchContext} from '../WatchContext'
import handleInputChange from "../tools/handleInputChange";
import calcSedConcern from "../tools/calcSedConcern";
import calcSedComplete from "../tools/calcSedComplete";


const HydroSed = () => {
  
  let {hydrosed, setHydrosed} = useContext(WatchContext);
  
  const handleChange = ({ target }) => {
    
    let data = handleInputChange(hydrosed, target)
    
    let concernedData = calcSedConcern(data)

    let completeData = calcSedComplete(concernedData)
  
    setHydrosed(completeData)
  };
  
  return (
    <>
      <General.Heading color={theme.colors.pdeBlue}>
        {hydrosed.title}
      </General.Heading>
      
      <Generic
     text={hydrosed.metric}
     title='Metric'
     />
      <Generic
     text={hydrosed.method}
     title='Method'
     />
      <Current
        currentValue={hydrosed.currentValue}
        // valDesc="Positive (+) values denote waterward movement of edge
        //     Negative (-) values denote landward movement of edge."
        units={hydrosed.units}
        just={hydrosed.currentJust}
        handleChange={handleChange}
        
      />
      <Criteria
        low={hydrosed.criteriaLow}
        high={hydrosed.criteriaHigh}
        units={hydrosed.units}
        type={hydrosed.criteriaType}
        just={hydrosed.criteriaJust}
        handleChange={handleChange}
      />
     <Generic
     align='center'
     title='Concerns'
     text={ <>
      <General.InputCont>
      <RenderIf isTrue={hydrosed.currentConcern === 1}>
      <General.BoldPara>
          {hydrosed.metric} currently falls outside the healthy range of values.
        </General.BoldPara>
    </RenderIf>
    <RenderIf isTrue={hydrosed.currentConcern === 0}>
      
        <p>
          {hydrosed.metric} currently falls within the healthy range of values.
        </p>
      
    </RenderIf>
    <RenderIf isTrue={hydrosed.currentConcern === -1}>
      
        <p>
          Need more information.
        </p>
      
    </RenderIf>
      </General.InputCont>
    
    
    </>}
     />
     
    </>
  );
};

export default HydroSed;
